/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from 'react';
import {View, Animated, StyleSheet} from 'react-native';
import {deleteMaintenanceById, fetchWorkOrders} from '../api';
import WorkOrderItem from '../components/WorkOrderItem';
import {useFocusEffect} from '@react-navigation/native';
import {E_NAVIGATION_DESTINATIONS} from '../../../@types';
import LoadingSpinner from '../../../components/LoadingSpinner';
import MySearchbar from '../../../components/MySearchbar';
import NavbarWithAction from '../../../components/NavbarWithAction';
import {useSelector} from 'react-redux';
import {RootStore} from '../../../redux/store';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../service/flashMessage';
import { getUnitLinkById } from '../../../api/links';
import {showKeyboardAwareAlert} from '../../../utils/keyboard';

export default function WorkOrders({navigation}) {
  const currentLink = useSelector(
    (state: RootStore) => state.units.unitLinks,
  ).find(link => link.isDefault === true);
  const [isLoading, setIsLoading] = useState(true);
  const [workOrders, setWorkOrders] = useState([]);
  const [isNavbarShown, setIsNavbarShown] = useState(true);
  const [searchKey, setSearchKey] = useState('');
  const [allowedToCreateWorkOrders, setAllowedToCreateWorkOrders] = useState(
    currentLink?.allowedToCreateWorkOrders ?? false,
  );

  useFocusEffect(
    React.useCallback(() => {
      getWorkOrders(searchKey);
    }, [searchKey]),
  );

  async function getWorkOrders(searchTerm: string) {
    setIsLoading(true);
    if (!currentLink?.unit?.id) {
      setWorkOrders([]);
      setIsLoading(false);
      return;
    }
    const res = await fetchWorkOrders(1, currentLink?.unit?.id, searchTerm);
    setWorkOrders(res);

    // const newUnitLink = await getUnitLinkById(currentLink.id);
    // setAllowedToCreateWorkOrders(newUnitLink.allowedToCreateWorkOrders);
    setIsLoading(false);
  }

  function deleteWorkOrder(id: string) {
    showKeyboardAwareAlert(
      'Confirm Close',
      'Do you really want to close the workorder ?',
      [
        {
          text: 'No',
          onPress: () => console.log('Cancel clicked'),
          style: 'cancel',
        },
        {
          text: 'Yes',
          onPress: async () => {
            await deleteMaintenanceById(id)
              .then(() => {
                showSuccessMessage('Work order Deleted successfully');
                getWorkOrders('');
              })
              .catch(e => showErrorMessage('WorkOrders' + e.message));
          },
        },
      ],
      {
        cancelable: false,
      },
    );
  }

  return (
    <View style={styles.container}>
      {isNavbarShown ? (
        <NavbarWithAction
          title={'Work Orders'}
          navigation={navigation}
          hasAdd={!isLoading && allowedToCreateWorkOrders}
          onClickAdd={() =>
            navigation.navigate(E_NAVIGATION_DESTINATIONS.CREATE_WORK_ORDER)
          }
          hasBackArrow
          hasSearch={workOrders.length > 0}
          onClickSearch={() => setIsNavbarShown(false)}
        />
      ) : (
        <MySearchbar
          placeholder={'Search work orders'}
          value={searchKey}
          setValue={setSearchKey}
          resetSearch={() => {
            setSearchKey('');
          }}
        />
      )}

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <View>
          <Animated.FlatList
            style={styles.list}
            data={workOrders.sort((a, b) => {
              const dateA = new Date(a.lastDateTime).getTime();
              const dateB = new Date(b.lastDateTime).getTime();
              return dateB - dateA;
            })}
            showsVerticalScrollIndicator={false}
            renderItem={({item}) => (
              <WorkOrderItem
                workOrder={item}
                allowedToClose={true}
                allowedToAddEdit={true}
                editWorkOrder={() =>
                  navigation.navigate(
                    E_NAVIGATION_DESTINATIONS.CREATE_WORK_ORDER,
                    {workOrder: item},
                  )
                }
                deleteWorkOrder={() => deleteWorkOrder(item.id)}
                onPress={() =>
                  navigation.navigate(
                    E_NAVIGATION_DESTINATIONS.WORK_ORDER_DETAILS,
                    {
                      workOrder: item,
                    },
                  )
                }
              />
            )}
            keyExtractor={({id}, _) => id}
            onRefresh={() =>
              currentLink?.unit?.id
                ? fetchWorkOrders(1, currentLink?.unit?.id, '')
                : undefined
            }
            refreshing={isLoading}
            contentContainerStyle={styles.listContent}
            onEndReachedThreshold={0.3}
          />
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  list: {
    marginBottom: 40,
    marginTop: 4,
  },
  listContent: {
    paddingBottom: 100,
  },
  fabContainer: {
    position: 'absolute',
    bottom: 10,
    right: 10,
  },
});
